import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const TakeOut = forwardRef(function TakeOut(props, ref) {
  const { color = '#000000', size = 24, ...others } = props;

  return (
    <svg
      fill={color}
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
      ref={ref}
      viewBox="0 0 22 22"
    >
      <path
        d="M15.954 12.668C15.3491 12.0001 14.7505 11.3384 14.1456 10.6705C13.9565 10.4626 13.8431 10.2231 13.8368 9.94587C13.8116 9.22123 13.7864 8.49659 13.7675 7.77195C13.7486 7.28676 13.528 7.05992 13.0617 7.04102H10.4783C10.0498 7.07882 9.75362 7.29306 9.55828 7.70894C8.76433 9.41027 7.97668 11.1116 7.15753 12.8003C6.85507 13.4178 6.96849 13.777 7.61752 14.0227C8.09011 14.2055 8.40516 14.111 8.63201 13.6573C8.97857 12.9641 9.32514 12.271 9.67801 11.5779C9.70321 11.5275 9.73472 11.4771 9.79143 11.3762C9.79143 11.8992 9.77252 12.3718 9.79773 12.8381C9.82924 13.4682 9.74732 14.0732 9.51418 14.6592C9.41966 14.9112 9.34404 15.1696 9.26213 15.4279C8.75803 17.0032 8.26024 18.5722 7.74984 20.1475C7.61752 20.5634 7.63642 20.9478 7.95148 21.2754C8.42407 21.7732 9.57089 21.8362 9.89855 20.8028C10.4972 18.9188 11.1021 17.0347 11.707 15.1507C11.7322 15.0687 11.7637 14.9805 11.8078 14.8608C11.9212 15.1381 12.0221 15.3775 12.1166 15.6106C12.4064 16.3164 12.7278 17.0158 12.8223 17.7783C12.9546 18.7991 13.0681 19.8261 13.1626 20.8532C13.213 21.3951 13.3768 21.8236 13.9376 22.0064C14.051 22.0064 14.1708 22.0064 14.2842 22.0064C14.3094 21.9938 14.3283 21.9812 14.3535 21.9749C15.0781 21.8173 15.4436 21.3321 15.3617 20.6012C15.2798 19.8703 15.1853 19.1393 15.0844 18.4084C14.9962 17.7468 14.908 17.0851 14.7946 16.4298C14.6434 15.598 14.2779 14.8356 13.9124 14.0795C13.6982 13.6321 13.7801 13.1847 13.7864 12.7058C13.8494 12.7373 13.8746 12.8003 13.9124 12.8444C14.2401 13.1973 14.574 13.5439 14.908 13.8841C15.1916 14.1677 15.5444 14.1614 15.828 13.8778C15.8658 13.84 15.8973 13.8022 15.9351 13.7644C16.3132 13.3863 16.3132 13.065 15.954 12.668Z"
        fill={color}
      />
      <path
        d="M12.2489 2.09452C12.0473 2.03151 11.833 2 11.6125 2C11.3856 2 11.1714 2.03151 10.9698 2.09452C10.1002 2.37177 9.46377 3.18463 9.46377 4.14241C9.46377 4.30624 9.48267 4.46377 9.52048 4.615C9.73472 5.57278 10.5917 6.28481 11.6125 6.28481C12.6333 6.28481 13.4902 5.57278 13.7045 4.615C13.736 4.46377 13.7612 4.30624 13.7612 4.14241C13.7549 3.18463 13.1248 2.37177 12.2489 2.09452Z"
        fill={color}
      />
    </svg>
  );
});

TakeOut.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TakeOut;
